<template>
  <div>
    <template v-if="addNewUserBooking">
      <validation-observer v-slot="{ invalid }" v-if="addBooking">
        <h5 class="mb-4">Add Booking</h5>

        <b-alert :show="showError.length" variant="warning">
          {{ showError }}
        </b-alert>

        <validation-provider
          v-for="(field, index) in date.fields"
          v-slot="context"
          :key="field.id"
          :name="field.field_label"
          :rules="`${field.required || field.is_default ? 'required' : ''}`"
        >
          <b-form-group :label="field.field_label">
            <b-form-input
              v-model="fields[index].value"
              :placeholder="field.placeholder"
              :state="getValidationState(context)"
              v-bind="context.ariaInput"
            />

            <b-form-invalid-feedback v-bind="context.ariaMsg">
              {{ context.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <h5>Choose giftcards to book</h5>
        <a
          href="#"
          class="border mb-2 p-3 cursor-pointer d-block"
          :disabled="giftcard.redeemed_at !== null"
          :class="{
            'bg-danger text-white': giftcard.redeemed_at !== null,
            'bg-light text-black': giftcard.redeemed_at === null && !giftcardsToBook.includes(giftcard),
            'bg-success text-white': giftcard.redeemed_at === null && giftcardsToBook.includes(giftcard),
          }"
          @click.prevent="toggleGiftcardToBook(giftcard)"
          v-for="(giftcard, index) in giftcardsForBooking"
          :key="giftcard.id"
        >
          <span>Giftcard #{{ index }}</span>
          {{ giftcard.code }} {{ giftcard.redeemed_at ? '(Redeemed)' : '' }}
        </a>

        <hr />

        <div class="clearfix">
          <div class="pull-right">
            <b-button variant="primary" :disabled="invalid" @click="book">
              Book
            </b-button>
          </div>
        </div>
      </validation-observer>

      <validation-observer v-else v-slot="{ invalid }">
        <h5 class="mb-4">Verify Giftcard</h5>

        <b-alert :show="showError.length" variant="warning">
          {{ showError }}
        </b-alert>

        <validation-provider name="Voucher Code" v-slot="context" rules="required">
          <b-form-group label="Voucher Code" label-for="voucher-code-id">
            <b-form-input
              v-model="giftcardCode"
              id="voucher-code-id"
              placeholder="e.g AD52893JD93J"
              :min="0"
              :state="getValidationState(context)"
              v-bind="context.ariaInput"
            />

            <b-form-invalid-feedback v-bind="context.ariaMsg">
              {{ context.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <hr />

        <div class="clearfix">
          <div class="pull-right">
            <b-button variant="link" class="mr-3" @click="cancelBookingForm">
              Cancel
            </b-button>

            <b-button variant="primary" :disabled="invalid" @click="verifyGiftcardCode">
              Verify Booking
            </b-button>
          </div>
        </div>
      </validation-observer>
    </template>

    <template v-else>
      <b-row class="mb-2">
        <b-col>
          <b-dropdown text="Export" size="sm" right class="pull-right">
            <b-dropdown-item-button v-for="(format, id) in formats" :key="id" @click="exportAs(format)">
              Export as {{ format.toUpperCase() }}
            </b-dropdown-item-button>
          </b-dropdown>
        </b-col>
      </b-row>

      <hr />
      <div class="clearfix">
        <b-button variant="primary" class="pull-right" @click="cancelBookingForm">
          Add Booking
        </b-button>
      </div>
    </template>

    <!-- Name	Email	Phone	Code -->
    <b-table :items="bookings" :fields="tableFields" :tbody-tr-class="rowClass">
      <template v-slot:cell(cancel)="row">
        <a v-if="!row.item.deleted_at" class="btn btn-sm btn-danger" href="#" @click.prevent="cancel(row.item.id)"
          >Cancel</a
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import { booking } from '@youwish1/api-package'
import { getValidationState } from '../pages/page-helpers'

export default {
  props: { date: Object },
  watch: {
    date() {
      console.log('changed')
      this.bookings = this.date.bookings
    },
  },
  data() {
    return {
      formats: ['xls', 'csv'],
      bookings: this.date.bookings,
      giftcardsForBooking: [],
      giftcardsToBook: [],
      addNewUserBooking: false,
      tableFields: [
        {
          key: 'name',
          label: 'Name',
          formatter: (value, key, item) => {
            return item.fields[0].value + ' ' + item.fields[1].value
          },
        },
        {
          key: 'email',
          label: 'Email',
          formatter: (value, key, item) => {
            return item.fields[2].value
          },
        },
        {
          key: 'phone',
          label: 'Phone',
          formatter: (value, key, item) => {
            return item.fields[3].value
          },
        },
        {
          key: 'code',
          label: 'Code',
        },
        {
          key: 'cancel',
          label: 'Cancel',
        },
      ],
      giftcardCode: '',
      showError: '',
      addBooking: false,
      fields: this.date.fields.map(field => ({
        booking_date_field_id: field.id,
        value: field.field_type === 'terms' ? false : '',
      })),
    }
  },
  computed: {
    bookingData() {
      return {
        booking_date_id: this.date.id,
        giftcard_code: this.giftcardCode,
        giftcard_ids: this.giftcardsToBook.map(g => g.id),
        confirmed: true,
        fields: this.fields,
      }
    },
  },
  methods: {
    getValidationState,
    rowClass(item, type) {
      if (!item || type !== 'row') return
      console.log(item)
      if (item.deleted_at) {
        return 'deleted-booking'
      }
      return 'test'
    },
    toggleGiftcardToBook(giftcard) {
      if (this.giftcardsToBook.find(g => g.id === giftcard.id)) {
        this.giftcardsToBook = this.giftcardsToBook.filter(item => item.id !== giftcard.id)
      } else {
        this.giftcardsToBook.push(giftcard)
      }
    },
    async exportAs(format) {
      const response = await booking.dates.export(this.date.id, format)
      this.$bvToast.toast(`Booking date export opened in new window`, {
        title: 'Booking date exported',
        variant: 'primary',
      })

      window.open(response.data.url)
    },
    cancelBookingForm() {
      this.addNewUserBooking = !this.addNewUserBooking
    },

    async cancel(id) {
      await booking.cancel(id)
      this.$emit('booking-added')
    },
    async verifyGiftcardCode() {
      try {
        const res = await booking.dates.verifyGiftcard(this.date.id, this.giftcardCode)

        this.showError = ''
        this.addBooking = true
        this.giftcardsForBooking = res.giftcards
      } catch (error) {
        this.showError = 'Invalid Giftcard'
        this.addBooking = false
      }
    },
    async book() {
      try {
        await booking.create(this.bookingData)
        this.$bvToast.toast(`Booking data create for supplier variation`, {
          title: 'Booking added',
          variant: 'primary',
        })

        this.giftcardsForBooking = []
        this.giftcardsToBook = []
        this.addNewUserBooking = false
        this.giftcardCode = ''
        this.addBooking = false

        this.$emit('booking-added')
      } catch (error) {
        const messages = error.errors[Object.keys(error.errors)[0]]

        this.showError = messages[0]
      }
    },
  },
}
</script>
<style lang="scss">
tr.deleted-booking {
  background: red;
  color: white;
}
</style>
